///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor = abcsetup.new_vendor || {};
abcsetup.new_vendor.workflow = abcsetup.new_vendor.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor.workflow = {
    // Variables
    workflow_task: null,
    disable_tab: true,

    /**
     *
     */
    init: function () {

        $('[data-toggle="tooltip"]').tooltip();

        if (abcsetup.userRole.class == 'new_rx_vendor' || abcsetup.userRole.class == 'new_consumer_vendor') {
            abcsetup.setTitle('New Supplier');
        } else {
            abcsetup.setTitle('SAP Supplier');
        }

        // Assign the local workflow_task var
        this.workflow_task = JSON.parse($('#WorkflowTask').val());

        // Reject button clicked
        $('#reject-btn, .reject-btn.required').on('click', function () {
            return abcsetup.new_vendor.workflow._rejectItem($(this));
        });

        // Bind the reject dropdown events
        this._bindRejectDropdown();

        // Apply any custom styles
        this._applyStyles();

        // Bind any form element behavior
        this._bindFormElems();

        $(document).on('change', '#reassign_user', function(event) {
            if ($(this).val()) {
                $('#reassign-confirm').prop('disabled', false);
            } else {
                $('#reassign-confirm').prop('disabled', true);
            }
        });

        $(document).on('click', '#reassign-confirm', function(event) {
            if (!$('#reassign_user').val()) {
                alert('Please select a user to reassign the task.');
                return;
            }

            axios.post('/new_vendor/' + abcsetup.new_vendor.workflow.workflow_task.id + '/workflow', {
                'form_action': 'reassign',
                'reassign_user': $('#reassign_user').val(),
            }).then(response => {
                window.location.href = '/dashboard';
            });
        });
    },

    /**
     * Bind the reject dropdown events
     */
    _bindRejectDropdown: function () {
        $('.dropdown-menu.reject input.checkbox').prop('checked', false);

        $(document).on('click', '.dropdown-menu.reject', function (event) {
            event.stopPropagation();
        });

        $(document).on('click', '.dropdown-menu.reject input.checkbox', function () {
            if ($(this).prop('checked')) {
                $(this).closest('div.checkbox').find('textarea').show();
            } else {
                $(this).closest('div.checkbox').find('textarea').hide().next('.errorMsg').remove();
            }
        });
    },

    /**
     * Reject the item
     */
    _rejectItem: function (btn) {

        // Existence of checkboxes
        if ($(':checkbox[name^="reject_reason"]')[0]) {
            if ($(':checkbox[name^="reject_reason"]:checked').length < 1) {
                abcsetup.alerts.show('Reject SAP Vendor', 'Please specify at least one reason to reject this vendor\'s information');
                return false;
            }

        // Existence of dropdown
        } else if ($('#reject_reason_dropdown')[0]) {
            if ($('#reject_reason_dropdown option:checked').val().length < 1) {
                abcsetup.alerts.show('Reject SAP Vendor', 'Please specify at least one reason to reject this vendor\'s information');
                return false;
            }

            if ($('textarea[name="reject_reason"]')[0] && $('textarea[name="reject_reason"]').val().length < 1) {
                abcsetup.alerts.show('Reject SAP Vendor', 'Please specify a reason to reject this vendor\'s information');
                return false;
            }

        // Check the reject reason field
        } else {
            let hasReason = false;
            let hasOption = false;

            /* Loop over all rejection reason fields, if there is no value in any of them, do not proceed */
            $('textarea.reject-description.required:visible').each(function() {
                if ($(this).val() != null && $(this).val() != '' && $(this).val() != undefined) {
                    $('textarea.reject-description.required:visible').removeClass('error');
                    hasReason = true;
                } else {
                    $('textarea.reject-description.required:visible').addClass('error');
                }
            });

            /* If we are the GSMD Team & we are rejecting to supplier, make sure at least 1 option has been selected. */
            if (abcsetup.userRole.class === 'gsmd_team' && btn.hasClass('reject_to_vendor')) {
                $('input[name="rejected_tasks"]').each(function() {
                    if ($(this).is(':checked')) {
                        hasOption = true;
                    }
                });
            }

            if (abcsetup.userRole.class === 'gsmd_team') {
                if (btn.hasClass('reject_to_vendor')) {
                    if (hasReason === false && hasOption === false) {
                        return false;
                    }
                } else if (hasReason === false) {
                    return false;
                }
            } else if (hasReason === false) {
                return false;
            }
        }

        btn.unbind('click').attr('type', 'submit').trigger('click');
    },

    /**
     * Bind any form element behavior
     */
    _bindFormElems: function() {
        // Disable the approve button unless the DSA is marked as execution
        if (this.workflow_task.task == 'brx_dsa_execution' || this.workflow_task.task == 'consumer_dsa_execution' || this.workflow_task.task == 'grx_new_vendor_dsa_execution') {
            $('#app_models_vendor__dsa_fully_executed, #app_models_vendor__dsa_fully_executed').bind('change', function() {
                $('.btn-success[value="approve"]').attr('disabled', true);
                if ($(this).val() == 1) {
                    $('.btn-success[value="approve"]').attr('disabled', false);
                }
            }).trigger('change');
        }

        // Disable the approve button unless the check is marked as received
        if (this.workflow_task.task == 'brand_rep_fivek_check_received' || this.workflow_task.task == 'consumer_rep_onek_check_received') {
            $('#app_models_vendor__fivek_check_received, #app_models_vendor__onek_check_received').bind('change', function() {
                $('.btn-success[value="approve"]').attr('disabled', true);
                if ($(this).val() == 1) {
                    $('.btn-success[value="approve"]').attr('disabled', false);
                }
            }).trigger('change');
        }

        // New Vendor Risk Team - Insurance docs review task rejection reason dropdown
        if (this.workflow_task.task == 'brx_insurance_docs_review' || this.workflow_task.task == 'grx_insurance_docs_review' || this.workflow_task.task == 'consumer_insurance_docs_review' || abcsetup.userRole.class == 'cgp_team') {
            $('#reject_reason_dropdown').on('change', function() {
                var reject_reason = $(this).find('option:selected').text();

                if (reject_reason != 'Other' && reject_reason != '- select -') {
                    $('textarea[name="reject_reason"]').val(reject_reason);
                } else {
                    $('textarea[name="reject_reason"]').val("");
                    $('textarea[name="reject_reason"]').removeAttr('readonly');
                }
            });
        }

        // Change the submit button form_action based on MSA execution state
        if (this.workflow_task.task == 'grx_new_vendor_msa_cm_approve' || this.workflow_task.task == 'grx_new_vendor_msa_swiss_approve') {
            $('#app_models_vendor__msa_executed, #app_models_vendor__swiss_executed').bind('change', function() {
                $('.btn-success[name="form_action"]').val('reject');
                if ($(this).val() == 1) {
                    $('.btn-success[name="form_action"]').val('approve');
                }
            }).trigger('change');
        }

        // Credit team approved with business to determine approval
        $(document).on('click', '#risky-approval-btn', function() {
            abcsetup.alerts.prompt('Allow the business to determine approval', 'Please add a comment to continue with approval:', function (resp) {
                if (resp[0] == true) {
                    $('#app_models_vendor__risky_comment').val(resp[1]);
                    $('#normal-approval-btn').trigger('click');
                }
            }, true);
        });

        // Do you plan to supply controlled substances to ABC
        $(document).on('change', '#app_models_vendor_CoverSheet_CoverSheet_controlled_substances', function() {
            if ($(this).val() == 0) {
                let licenses = JSON.parse($('#WorkflowTask').val())?.for_entity?.licenses;
                let hasDea = false;

                for (let license in licenses) {
                    if (licenses[license] == 'primary_dea') {
                        hasDea = true;
                    }
                }

                // Disable the Primary DEA requirement if the primary dea licenses box wasnt checked
                if (hasDea == false) {
                    $(':input[name^="licenses"][value="primary_dea"]').prop('checked', false);
                }

                $(':input[name^="licenses"][value="primary_dea"]').attr('readonly', false);

                if (abcsetup.userRole.class != 'new_consumer_vendor') {
                    abcsetup.new_vendor.workflow._toggleLicenses();

                    /* ABCS-3555 If this is no all control_license fields must be hidden & not rquired */
                    $('.control_license_file_field').each(function() {
                        $(this).attr('required', false);
                        $(this).parent().parent().removeClass('required').addClass('d-none');
                    });
                }

            } else {
                abcsetup.new_vendor.workflow._applyLicenses(false);

                /* ABCS-3555 If this is yes all control_license fields must be required */
                $('.control_license_file_field').each(function() {
                    $(this).attr('required', true);
                    $(this).parent().parent().addClass('required').removeClass('d-none');
                });
            }
        });

        // Authorized Trading Partner table
        $(document).on('change keyup', '.authorized_trading_partner_table input', function() {
            var blankRow = false;

            $('.authorized_trading_partner_table').each(function() {
                if ($(this).find('input').filter(function() { return $(this).val() === ''; }).length == 3) {
                    blankRow = true;
                }
            })

            if (!blankRow) {
                var row = $('.authorized_trading_partner_table:last').clone();
                row.find('input').val('').attr('required', false).attr('requiredIf', '').removeClass('invalid');

                // Apply a uid to the 2 fields and make them dependant on eachother
                var id = abcsetup.randomString();
                row.find('input.authorized_trading_partner_ein').attr('id', 'authorized_trading_partner_ein_' + id).attr('requiredIf', 'authorized_trading_partner_affiliate_names_' + id + '!=');
                row.find('input.authorized_trading_partner_affiliate_names').attr('id', 'authorized_trading_partner_affiliate_names_' + id).attr('requiredIf', 'authorized_trading_partner_ein_' + id + '!=');
                row.find('input.authorized_trading_partner_ein_start_dates').attr('id', 'authorized_trading_partner_ein_start_dates_' + id).attr('requiredIf', 'authorized_trading_partner_ein_' + id + '!=');
                row.find('small').remove();
                $('.authorized_trading_partner_table:last').after(row);
            }
        });

        $('.authorized_trading_partner_table input').eq(0).trigger('change');

        // BRx and GRx licenses
        if (this.workflow_task.task == 'brx_other_supplier_forms' || this.workflow_task.task == 'grx_new_vendor_other_supplier_forms') {
            // Auto check and disabled the license checkboxes when divisions change

            abcsetup.new_vendor.workflow._applyLicenses();

            // Toggle the licenses tabs
            $(':checkbox[name^="licenses"]').on('change', function() {
                abcsetup.new_vendor.workflow._toggleLicenses();
            });

            // Maybe toggle license tab when home state is selected
            $('#app_models_vendor_license_home_license_home_license_state').on('change', () => {
                /* ABCS-4272 If the Home License has special rules, like Ohio, reset these fields and reset the label as well. */
                $('#app_models_vendor_license_home_license_home_license_third_party').val(null);
                $('#app_models_vendor_license_home_license_home_license_title_model').val(null);

                $('#app_models_vendor_license_home_license_home_license_third_party_license').parent().parent().find('label').text('State 3PL License');

                abcsetup.new_vendor.workflow._toggleLicenses();
            });

            $(':checkbox[name^="licenses"]:first').trigger('change');
        }

        // Add license expiration alerts for each state
        if (abcsetup.userRole.class == 'new_rx_vendor' || abcsetup.userRole.class == 'new_consumer_vendor' || abcsetup.userRole.class == 'gsmd_team') {
            let alabamaLicense = $('#app_models_vendor_license_alabama_license_alabama_license_expiration_date');
            let coloradoLicense = $('#app_models_vendor_license_colorado_license_colorado_license_expiration_date');
            let floridaLicense = $('#app_models_vendor_license_florida_license_florida_license_expiration_date');
            let mississippiLicense = $('#app_models_vendor_license_mississippi_license_mississippi_license_expiration_date');
            let missouriLicense = $('#app_models_vendor_license_missouri_license_missouri_license_expiration_date');
            let northCarolinaLicense = $('#app_models_vendor_license_north_carolina_license_north_carolina_license_expiration_date');
            let ohioLicense = $('#app_models_vendor_license_ohio_license_ohio_license_expiration_date');
            let oregonLicense = $('#app_models_vendor_license_oregon_license_oregon_license_expiration_date');
            let texasLicense = $('#app_models_vendor_license_texas_license_texas_license_expiration_date');

            // Alabama
            let alabamaExpirationDate = moment(alabamaLicense.val(), "YYYY-MM-DD");
            if (moment.duration(alabamaExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The Alabama State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            alabamaLicense.on('change', function () {
                if ($(this).val()) {
                    let alabamaExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(alabamaExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The Alabama State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });

            // Colorado
            let coloradoExpirationDate = moment(coloradoLicense.val(), "YYYY-MM-DD");
            if (moment.duration(coloradoExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The Colorado State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            coloradoLicense.on('change', function () {
                if ($(this).val()) {
                    let coloradoExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(coloradoExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The Colorado State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });

            // Florida
            let floridaExpirationDate = moment(floridaLicense.val(), "YYYY-MM-DD");
            if (moment.duration(floridaExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The Florida State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            floridaLicense.on('change', function () {
                if ($(this).val()) {
                    let floridaExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(floridaExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The Florida State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });

            // Mississippi
            let mississippiExpirationDate = moment(mississippiLicense.val(), "YYYY-MM-DD");
            if (moment.duration(mississippiExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The Mississippi State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            mississippiLicense.on('change', function () {
                if ($(this).val()) {
                    let mississippiExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(mississippiExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The Mississippi State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });

            // Missouri
            let missouriExpirationDate = moment(missouriLicense.val(), "YYYY-MM-DD");
            if (moment.duration(missouriExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The Missouri State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            missouriLicense.on('change', function () {
                if ($(this).val()) {
                    let missouriExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(missouriExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The Missouri State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });

            // North Carolina
            let northCarolinaExpirationDate = moment(northCarolinaLicense.val(), "YYYY-MM-DD");
            if (moment.duration(northCarolinaExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The North Carolina State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            northCarolinaLicense.on('change', function () {
                if ($(this).val()) {
                    let northCarolinaExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(northCarolinaExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The North Carolina State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });

            // Ohio
            let ohioExpirationDate = moment(ohioLicense.val(), "YYYY-MM-DD");
            if (moment.duration(ohioExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The Ohio State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            ohioLicense.on('change', function () {
                if ($(this).val()) {
                    let ohioExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(ohioExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The Ohio State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });

            // Oregon
            let oregonExpirationDate = moment(oregonLicense.val(), "YYYY-MM-DD");
            if (moment.duration(oregonExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The Oregon State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            oregonLicense.on('change', function () {
                if ($(this).val()) {
                    let oregonExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(oregonExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The Oregon State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });

            // Texas
            let texasExpirationDate = moment(texasLicense.val(), "YYYY-MM-DD");
            if (moment.duration(texasExpirationDate.diff(moment())).asDays() <= 45) {
                abcsetup.alerts.confirm("WARNING: License Expiration", "The Texas State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
            }
            texasLicense.on('change', function () {
                if ($(this).val()) {
                    let texasExpirationDate = moment($(this).val(), "YYYY-MM-DD");
                    if (moment.duration(texasExpirationDate.diff(moment())).asDays() <= 45) {
                        abcsetup.alerts.confirm("WARNING: License Expiration", "The Texas State license has expired or is about to expire. Please make sure this is updated or reviewed before submitting.");
                    }
                }
            });
        }

        if (abcsetup.userRole.class == 'cgp_team') {
            $('a').each(function() {
                if ($(this).text().toLowerCase() == 'replace' || $(this).text().toLowerCase() == 'delete') {
                    $(this).hide();
                }
            });
        }

        // Prevent credit team or GSMD roles from submitting workflow if any COL are expired
        if (abcsetup.userRole.class == 'gsmd_team' || abcsetup.userRole.class == 'credit_team' || this.workflow_task.task == 'consumer_insurance_docs_review') {
            $('#indemnification_insurance_contact').each(function () {
                if ($(this).val() != "") {
                    const given = $(this).val();
                    const today = moment().format('YYYY-MM-DD');

                    if (abcsetup.userRole.class == 'gsmd_team' || abcsetup.userRole.class == 'risk_management') {
                        if (today >= given) {
                            $(':input[type="submit"]').addClass('manual-disabled');
                            $('.btn-success[value="approve"]').prop('disabled', true);
                            abcsetup.alerts.show('Notice of Expiration', 'The end date for the Certificate of Liability Insurance has passed. Please reject back to supplier for corrections.');
                        } else {
                            $('.btn-success[value="approve"]').prop('disabled', false);
                        }
                    }

                    if (abcsetup.userRole.class == 'credit_team') {
                        if (today >= given) {
                            $('#credit-team-approve').prop('disabled', true);
                            abcsetup.alerts.show('Notice of Expiration', 'The end date for the Certificate of Liability Insurance has passed. Please reject back to supplier for corrections.');
                        } else {
                            $('#credit-team-approve').prop('disabled', false);
                        }
                    }
                }
            });
        }

        // Prevent GSMD roles from submitting workflow if any licenses are expired
        if (abcsetup.userRole.class == 'gsmd_team') {
            $(':input[type="submit"]').addClass('manual-disabled');
            let pendingCount = 0;
            let expiredCount = 0;

            $('.is-pending').each(function () {
                if ($(this).val() == 1) {
                    pendingCount++;
                }
            });

            $('.expiration_date').each(function () {
                const expirationDate = $(this).val();

                if (expirationDate != "") {
                    const today = moment().format('YYYY-MM-DD');

                    if (today >= expirationDate) {
                        expiredCount++;
                    }
                }
            });

            if (expiredCount > 0 && pendingCount == 0) {
                $('.btn-success[value="approve"]').prop('disabled', true);
            } else if (expiredCount > 0 && pendingCount > 0) {
                $('.btn-success[value="approve"]').prop('disabled', false);
            } else {
                $('.btn-success[value="approve"]').prop('disabled', false);
            }
        }

        // Prevent New Supplier from submitting if COI is expired
        if (abcsetup.userRole.class == 'new_rx_vendor' || abcsetup.userRole.class == 'new_consumer_vendor') {
            $(':input[type="submit"]').addClass('manual-disabled');
            $('#app_models_vendor_contact_indemnification_insurance_contact_indemnification_insurance_contact_liability_certificate_end_date').each(function () {
                if ($(this).val() != "") {
                    const given = $(this).val();
                    const today = moment().format('YYYY-MM-DD');

                    if (today >= given) {
                        $('.btn-success[value="approve"]').prop('disabled', true);
                        abcsetup.alerts.show('Notice of Expiration', 'The expiration date cannot be in the past. Please provide a current, active COI with a future expiration date.');
                    } else {
                        $('.btn-success[value="approve"]').prop('disabled', false);
                    }
                }
            });

            $('#app_models_vendor_contact_indemnification_insurance_contact_indemnification_insurance_contact_liability_certificate_end_date').on('change', function () {
                if ($(this).val() != "") {
                    const given = $(this).val();
                    const today = moment().format('YYYY-MM-DD');

                    if (today >= given) {
                        $('.btn-success[value="approve"]').prop('disabled', true);
                        abcsetup.alerts.show('Notice of Expiration', 'The expiration date cannot be in the past. Please provide a current, active COI with a future expiration date.');
                    } else {
                        $('.btn-success[value="approve"]').prop('disabled', false);
                    }
                }
            });
        }


        // Add warning message when awaiting state license approval checkbox is checked (not Oregon)
        if (this.workflow_task.task == 'grx_new_vendor_other_supplier_forms' || this.workflow_task.task == 'brx_other_supplier_forms' || this.workflow_task.task == 'consumer_other_supplier_forms') {
            var approvalChecks = [
                $('#app_models_vendor_license_primary_dea_primary_dea_awaiting_approval'),
                $('#app_models_vendor_license_secondary_dea_secondary_dea_awaiting_approval'),
                $('#app_models_vendor_license_home_license_home_license_awaiting_approval'),
                $('#app_models_vendor_license_alabama_license_alabama_license_awaiting_approval'),
                $('#app_models_vendor_license_colorado_license_colorado_license_awaiting_approval'),
                $('#app_models_vendor_license_florida_license_florida_license_awaiting_approval'),
                $('#app_models_vendor_license_mississippi_license_mississippi_license_awaiting_approval'),
                $('#app_models_vendor_license_missouri_license_missouri_license_awaiting_approval'),
                $('#app_models_vendor_license_mississippi_license_mississippi_license_awaiting_approval'),
                $('#app_models_vendor_license_north_carolina_license_north_carolina_license_awaiting_approval'),
                $('#app_models_vendor_license_ohio_license_ohio_license_awaiting_approval'),
                $('#app_models_vendor_license_texas_license_texas_license_awaiting_approval'),
            ];

            var mapApprovals = $.map(approvalChecks, function (el) {
                return el.get()
            });

            $(mapApprovals).each(function () {
                let checkbox = $(this);

                if (checkbox.is(':checked')) {
                    abcsetup.alerts.show('WARNING', 'WARNING: Cencora will NOT purchase items into the distribution center within this state without this license. Please click Close to continue.');
                    const formDiv = $(this).closest('.form-div').find(':input').not('.awaiting_approval');
                    formDiv.each(function() {
                        $(this).val('');
                        $(this).on('change keyup', function () {
                            if (checkbox.is(':checked')) {
                                $(this).val('');
                                abcsetup.alerts.show('WARNING', 'WARNING: In order to add your license, please uncheck the Awaiting state license approval checkbox.');
                            }
                        });
                    });
                }
            });

            $(mapApprovals).on('click', function () {
                let checkbox = $(this);

                if (checkbox.is(':checked')) {
                    abcsetup.alerts.show('WARNING', 'WARNING: Cencora will NOT purchase items into the distribution center within this state without this license. Please click Close to continue.');
                    const formDiv = $(this).closest('.form-div').find(':input').not('.awaiting_approval');
                    formDiv.each(function() {
                        $(this).val('');
                        $(this).on('change keyup', function () {
                            if (checkbox.is(':checked')) {
                                $(this).val('');
                                abcsetup.alerts.show('WARNING', 'WARNING: In order to add your license, please uncheck the Awaiting state license approval checkbox.');
                            }
                        });
                    });
                }
            });

            // Oregon specific message - awaiting state license approval checkbox is checked
            var oregonAprrovalCheck = $('#app_models_vendor_license_oregon_license_oregon_license_awaiting_approval');

            $(oregonAprrovalCheck).each(function () {
                let checkbox = $(this);

                if (checkbox.is(':checked')) {
                    abcsetup.alerts.show('WARNING', 'WARNING: Cencora will NOT be able to purchase items for sale to customers in this state without this license. Please Close Okay to continue.');
                    const formDiv = $(this).closest('.form-div').find(':input').not('.awaiting_approval');
                    formDiv.each(function() {
                        $(this).val('');
                        $(this).on('change keyup', function () {
                            if (checkbox.is(':checked')) {
                                $(this).val('');
                                abcsetup.alerts.show('WARNING', 'WARNING: In order to add your license, please uncheck the Awaiting state license approval checkbox.');
                            }
                        });
                    });
                }
            });

            $(oregonAprrovalCheck).on('click', function () {
                let checkbox = $(this);

                if (checkbox.is(':checked')) {
                    abcsetup.alerts.show('WARNING', 'WARNING: Cencora will NOT purchase items into the distribution center within this state without this license. Please click Close to continue.');
                    const formDiv = $(this).closest('.form-div').find(':input').not('.awaiting_approval');
                    formDiv.each(function() {
                        $(this).val('');
                        $(this).on('change keyup', function () {
                            if (checkbox.is(':checked')) {
                                $(this).val('');
                                abcsetup.alerts.show('WARNING', 'WARNING: In order to add your license, please uncheck the Awaiting state license approval checkbox.');
                            }
                        });
                    });
                }
            });

            /* ABCS-3555 The label for this form  */
            $(document).on('change', '.title_model', function(e) {
                let formTab = $(this).closest('.form-div');
                let tabWiz = formTab.attr('id');
                let label = formTab.find('.third_party_license').parent().parent().find('label');
                let selectedHomeState = $('#app_models_vendor_license_home_license_home_license_state').find(":selected").text();

                if (tabWiz == 'wiz-home_license' || tabWiz == 'wiz-florida_license' || tabWiz == 'wiz-mississippi_license' || tabWiz == 'wiz-north_carolina_license' || tabWiz == 'wiz-ohio_license') {
                    let skipStates = ['Texas', 'Missouri', 'Colorado'];

                    /* Home License Specific tab */
                    if (tabWiz == 'wiz-home_license' && $(this).val() != null) {
                        if (skipStates.includes(selectedHomeState) && $(this).val() == 0) {
                            label.text("State 3PL License");
                        } else if (!skipStates.includes(selectedHomeState) && $(this).val() == 1) {
                            label.text("Only license of company taking title is required (MUST be Wholesaler license, not 3PL)");
                        }

                        return;
                    }

                    if ($(this).val() != null && $(this).val() == 0) {
                        label.text("State 3PL License");
                    } else if ($(this).val() != null && $(this).val() == 1) {
                        label.text("Only license of company taking title is required (MUST be Wholesaler license, not 3PL)");
                    }
                }
            });

            /* ABCS-3555 If Third Party is No or Select & Title Model has a value - set the value to null */
            $(document).on('change', '.third_party', function(e) {
                let formTab = $(this).closest('.form-div');

                if ($(this).val() != 1 && formTab.find('.title_model').val() != null) {
                    formTab.find('.title_model').val(null);
                }
            });
        }

        // Check pending license checkbox on CSRA team's view if state licenses are awaiting approval
        if (this.workflow_task.task == 'brx_license_docs_review' || this.workflow_task.task == 'grx_new_vendor_license_docs_review') {
            $('.awaiting_approval').each(function () {
                if ($(this).val() == '1') {
                    $(this).closest('.form-div').find('.is-pending').prop('checked', true).prop('disabled', true);
                }
            });

            // Bind change event for pending license checkbox
            $('.is-pending').on('change', function () {
                const isChecked = $(this).is(':checked');
                const formGroup = $(this).closest('.form-div');

                formGroup.find('input.expiration_date, input[name*="_effective_date"]').each(function () {
                    $(this).prop('readonly', isChecked).closest('.form-group').toggleClass('disabled', isChecked);
                });

                // Ensure the checkbox's state is submitted
                if (!isChecked) {
                    formGroup.append('<input type="hidden" name="' + $(this).attr('name') + '" value="0">');
                } else {
                    formGroup.find('input[type="hidden"][name="' + $(this).attr('name') + '"]').remove();
                }

                // Update the approve button state
                abcsetup.new_vendor.workflow._toggleApproveButtonState();
            }).trigger('change');
        }

        // Add helpText to each state license - TODO: this should be done at the field level
        $(':input[name^="licenses"][value="alabama_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for all Divisions 10, 20, 30 and 40</small>');
        $(':input[name^="licenses"][value="colorado_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="florida_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="mississippi_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="missouri_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="north_carolina_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="ohio_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40</small>');
        $(':input[name^="licenses"][value="oregon_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for all Divisions 10, 20, 30 and 40</small>');
        $(':input[name^="licenses"][value="home_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for all Divisions 10, 20, 30 and 40</small>');
        $(':input[name^="licenses"][value="texas_license"]').closest('.form-group').append('<small class="form-text text-muted text-danger pl-4">Required for Division 10 set up. Strongly preferred for Division 20, 30 and/or 40.</small>');

        // Remit To Country changed
        $('#app_models_vendor_contact_remit_to_contact_remit_to_contact_country').bind('change', function() {
            $('#app_models_vendor_contact_remit_to_contact_remit_to_contact_zip_code').unmask().attr('placeholder', '')

            // Validate zip codes in the US
            if ($(this).val() == 'US') {
                $('#app_models_vendor_contact_remit_to_contact_remit_to_contact_zip_code').mask("99999").attr('placeholder', 'XXXXX')
            }
        }).trigger('change');

        // Signature invite button
        $(document).on('click', '.btn-signature-invite', function() {
            var _link = $(this);
            _link.css("cursor", "progress");

            axios.post('/api/new_vendor/send_signature', {
                'tag': _link.data('field-tag'),
                'column': _link.data('field-column'),
                'email': _link.closest('.row').find('input').val(),
                'workflow_task_id': abcsetup.new_vendor.workflow.workflow_task.id,
            }).then(response => {
                _link.css('cursor', 'pointer');
                abcsetup.alerts.show('Signature Email Sent', 'We\'ve sent a signature request email to the address you specified.');
            });
        });

        //Autofill email delegate value - NDA - Vendor Approve
        let vendorNdaDelegateEmail = $('#nda_vendor_delegate_email').val();
        $('#app_models_vendor_contact__nda_vendor_signature').val(vendorNdaDelegateEmail);

        // Ship From / 3PL logistics
        $(document).on('change', 'input.bootstrap-toggle', function() {
            if (!abcsetup.new_vendor.workflow.disable_tab) {
                return false;
            }

            const formDivID = $(this).closest('.form-div').attr('id');

            if (formDivID == 'wiz-ship_from_contact') {
                var targetDiv = $('#wiz-third_party_contact');
            } else if (formDivID == 'wiz-third_party_contact') {
                var targetDiv = $('#wiz-ship_from_contact');
            }

            if (targetDiv) {
                abcsetup.new_vendor.workflow.disable_tab = false;
                setTimeout('abcsetup.new_vendor.workflow.disable_tab = true;', 1000);
                targetDiv.find('.bootstrap-toggle').bootstrapToggle($(this).prop('checked') ? 'off' : 'on');
            }
        });

        // Toggle the Confidential checkboxes for Net Worth and Annual sales if Private business (credit eval)
        $(document).on('change', '#app_models_vendor__is_public', function () {
            if ($('#app_models_vendor__is_public').val() == '0') {
                $('#app_models_vendor__net_worth_confidential').parent().show();
                $('#app_models_vendor__annual_sales_confidential').parent().show();
                $('#app_models_vendor__balance_sheet_confidential').parent().show();
                $('#app_models_vendor__income_statement_confidential').parent().show();
            } else {
                $('#app_models_vendor__net_worth_confidential').prop('checked', false).trigger('change').parent().hide();
                $('#app_models_vendor__annual_sales_confidential').prop('checked', false).trigger('change').parent().hide();
                $('#app_models_vendor__balance_sheet_confidential').prop('checked', false).trigger('change').parent().hide();
                $('#app_models_vendor__income_statement_confidential').prop('checked', false).trigger('change').parent().hide();
            }
        });

        // Toggle Confidential checkboxes based on file upload
        $(document).on('change', '#app_models_vendor__balance_sheet', function () {
            $('#app_models_vendor__balance_sheet_confidential').trigger('change').parent().hide();
        });

        $(document).on('change', '#app_models_vendor__income_statement', function () {
            $('#app_models_vendor__income_statement_confidential').trigger('change').parent().hide();
        });

        $(document).on('change', '#app_models_vendor_CreditEval_CreditEval_balance_sheet', function () {
            $('#app_models_vendor_CreditEval_CreditEval_balance_sheet_confidential').trigger('change').parent().hide();
        });

        $(document).on('change', '#app_models_vendor_CreditEval_CreditEval_income_statement', function () {
            $('#app_models_vendor_CreditEval_CreditEval_income_statement_confidential').trigger('change').parent().hide();
        });

        // Show alert to GSMD when company name is 35 chars or greater
        if (abcsetup.userRole.class == 'gsmd_team') {
            $(document).on('change', '#app_models_vendor_contact_supplier_contact_supplier_contact_name', function () {
                if (this.value.length >= 35) {
                    abcsetup.alerts.show('Company Name Length Warning', 'The length of the company name is currently equal to or greater than 35 characters. A length of no more than 40 characters is allowed.');
                }
            });

            //if cgp & reject reasons, hide boilerplate fieldcollection reject reason box
            if ($('#cgp_rejected')[0]) {
                $('#reject_reasons').hide();
            }
        }

        // Highlight licenses that have been flagged as pending
        if (this.workflow_task.task == 'grx_new_vendor_gsmd_approve' ||
            this.workflow_task.task == 'brx_new_vendor_gsmd_approve') {

          $('input[data-license-is-pending-and-vendor-blocked="1"]')
            .closest('div')
            .addClass('highlight py-2 px-3');
        }

        // Add text to top of ATP tab for user
        if (this.workflow_task.task == 'consumer_other_supplier_forms') {
            $('#wiz-authorized_trading_partner')
              .find('.row')
              .first()
              .before('<div class="font-weight-bold pb-2">Toggle this form off if you are not using an Authorized Trading Partner</div>')
          }

        // Sync duplicated fields when any one of the duplicates are changed
        if (this.workflow_task.task == 'brx_supplier_forms' ||
            this.workflow_task.task == 'grx_new_vendor_supplier_forms' ||
            this.workflow_task.task == 'consumer_supplier_forms') {

            $(document).ready(function() {

                const syncData = function(input, fieldGroupName) {
                    input.change(function () {
                        let value = input.val();
                        abcsetup.new_vendor.workflow._syncDuplicatedInputValues(value, fieldGroupName);
                    });
                }

                // Add listeners to all Tax ID Number Fields
                if (($('#app_models_vendor_contact_third_party_contact_third_party_contact_third_party_relationship').val() != '3PL') && ($('#app_models_vendor_contact_return_contact_return_contact_return_type').val() != '3pl')) {
                    abcsetup.new_vendor.workflow._duplicatedInputGroups()['taxIDNumber']
                        .forEach((input) => syncData(input, 'taxIDNumber'));
                }

                // Add listeners to all DEA Number Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['DEANumber']
                    .forEach((input) => syncData(input, 'DEANumber'));

                // Add listeners to all DEA Expiration Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['DEAExpiration']
                    .forEach((input) => syncData(input, 'DEAExpiration'));

                // Add listeners to all 3rd Party Logistics Name Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['threePLName']
                    .forEach((input) => syncData(input, 'threePLName'));

                // Add listeners to all 3rd Party Logistics DEA Number Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['threePLDEANumber']
                    .forEach((input) => syncData(input, 'threePLDEANumber'));

                // Add listeners to all 3rd Party Logistics DEA Expiration Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['threePLExpiration']
                    .forEach((input) => syncData(input, 'threePLExpiration'));

                // Add listeners to all DUNS Number Fields
                if (('#app_models_vendor_contact_third_party_contact_third_party_contact_third_party_relationship' != '3PL') && ('#app_models_vendor_contact_return_contact_return_contact_return_type' != '3pl')) {
                    abcsetup.new_vendor.workflow._duplicatedInputGroups()['duns']
                        .forEach((input) => syncData(input, 'duns'));
                }

                // Add listeners to all Labeler Code Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['labelerCode']
                    .forEach((input) => syncData(input, 'labelerCode'));

                // Add listeners to all GS1 Global Location Number Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['GS1LocationNumber']
                    .forEach((input) => syncData(input, 'GS1LocationNumber'));

                // Add listeners to all GS1 Company Prefix Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['GS1CompanyPrefix']
                    .forEach((input) => syncData(input, 'GS1CompanyPrefix'));

                // Add listeners to all HIN Fields
                abcsetup.new_vendor.workflow._duplicatedInputGroups()['HIN']
                    .forEach((input) => syncData(input, 'HIN'));
            });
        }

        // Labeler Codes
        $(document).on('change keyup', 'div.labeler_codes input', function() {
            var blankRow = false;

            $('.labeler_codes').each(function() {
                // Updated length == 1 from length == 3 per ABCS-2855
                if ($(this).find('input').filter(function() { return $(this).val() === ''; }).length == 1) {
                    blankRow = true;
                }
            })

            if (!blankRow) {
                var row = $('.labeler_codes:last').clone();
                row.find('input').val('').attr('required', false).attr('requiredIf', '').removeClass('invalid');
                row.find('div.form-group').removeClass('required');

                // Apply a uid to the 2 fields and make them dependant on eachother
                var id = abcsetup.randomString();
                row.find('input.LabelerCodes_number').attr('id', 'LabelerCodes_number' + id);

                // Commenting out per ABCS-2855
                // row.find('input.LabelerCodes_effective_date').attr('id', 'LabelerCodes_effective_date' + id).attr('requiredIf', 'LabelerCodes_number' + id + '!=');
                // row.find('input.LabelerCodes_expiration_date').attr('id', 'LabelerCodes_expiration_date' + id).attr('requiredIf', 'LabelerCodes_number' + id + '!=');

                row.find('small').remove();
                $('.labeler_codes:last').after(row);
            }
        });

        $('.labeler_codes input').eq(0).trigger('change');

        // Make the ATP checkboxes required when the associated field is filled out
        $(document).on('change', '#app_models_vendor_contact_authorized_trading_partner_authorized_trading_partner_fda_identifiers', function() {
            if ($(this).val() != '') {
                $('#dscsa_statuses_1').attr('required', true);
            } else {
                $('#dscsa_statuses_1').attr('required', false);
            }
        });

        $(document).on('change', '#app_models_vendor_contact_authorized_trading_partner_authorized_trading_partner_fda_facility_repackager', function() {
            if ($(this).val() != '') {
                $('#dscsa_statuses_2').attr('required', true);
            } else {
                $('#dscsa_statuses_2').attr('required', false);
            }
        });

        $('#app_models_vendor_contact_authorized_trading_partner_authorized_trading_partner_fda_identifiers, #app_models_vendor_contact_authorized_trading_partner_authorized_trading_partner_fda_facility_repackager').trigger('change');

        if (this.workflow_task.task == 'grx_new_vendor_nda_approve') {
            $(document).on('click', '#btn-reject', function() {
                    abcsetup.alerts.show('Reject Non-Disclosure Agreement Document', 'Wait! Make sure you have replaced the existing NDA with your redlines! Click continue to proceed.');
            });
        }

        if (this.workflow_task.task == 'grx_new_vendor_nda_approve' || this.workflow_task.task == 'brx_new_vendor_nda_approve') {
            $(document).on('change', '#app_models_vendor__nda_already_signed', function(e) {
                /* ABCS-3501, if NDA is already signed, change form action */
                $('[name="form_action"]').val($(this).val() == '1' ? 'approve_existing_nda' : 'approve');
            });
        }

        // Check supplier type to determine default processing fee
        if (this.workflow_task.task == 'brx_dsa_execution' || this.workflow_task.task == 'grx_new_vendor_dsa_execution') {
            $(document).on('change','#app_models_vendor__fivek_check_required', function() {
                if ($('#app_models_vendor__vendor_type').val() == 'dropship_supplier') {
                    $('#app_models_vendor__processing_fee').val('500.00');
                } else {
                    $('#app_models_vendor__processing_fee').val('5000.00');
                }
            });
        }

        if (this.workflow_task.task == 'consumer_dsa_execution') {
            $(document).on('change','#app_models_vendor__onek_check_required', function() {
                if ($('#app_models_vendor__vendor_type').val() == 'dropship_supplier') {
                    $('#app_models_vendor__processing_fee').val('500.00');
                } else {
                    $('#app_models_vendor__processing_fee').val('1000.00');
                }
            });
        }

        if (
            this.workflow_task.task == 'brx_atp_document_rejected' ||
            this.workflow_task.task == 'grx_new_vendor_atp_document_rejected' ||
            this.workflow_task.task == 'consumer_atp_document_rejected'
           ) {

            $('#app_models_vendor_contact_authorized_trading_partner_authorized_trading_partner_signature').val('');
        }

        $("#app_models_vendor_contact_indemnification_insurance_contact_indemnification_insurance_contact_umbrella_insurance_start_date").on("change", function(){
            $("#app_models_vendor_contact_indemnification_insurance_contact_indemnification_insurance_contact_umbrella_insurance_end_date").attr("min", $(this).val());
        }).trigger("change");

        /* ABCS-3370 Credit Eval Delegation */

        /* Consumer Credit Eval JS hacks because field collections logic wont work on non-tabbed form collection. */
        const type = JSON.parse($('#WorkflowTask').val()).for_entity.type;
        const delegated = JSON.parse($('#WorkflowTask').val()).for_entity.credit_eval_delegate_email;
        const delegation_completed = JSON.parse($('#WorkflowTask').val()).for_entity.credit_eval_delegate_task_completed;
        let state_type = 'refreshed';

        if (this.workflow_task.task == 'consumer_credit_evaluation') {
            let state = 'off';

            /* If previously saved, delegate email is present & delegation task not completed - make sure to click checkbox */
            if (delegated && delegation_completed == null) {
                $('#credit_eval_delegate').click();
            }

            if ($('#delegate_credit_eval_btn').length) {
                $('#app_models_vendor__credit_eval_delegate_email').attr('disabled', true);
                $('#app_models_vendor__credit_eval_delegate_email').removeAttr('required');
                $('#app_models_vendor__credit_eval_delegate_email').parent().parent().removeClass('required');
                $('#delegate_credit_eval_btn').attr('disabled', true);
            }

            $(document).on('change', '.credit_eval_delegate', function(e) {
                state = state === 'off' ? 'on' : 'off';

                if (state == 'on') {
                    $('#app_models_vendor__credit_eval_delegate_email').attr('disabled', false);
                    $('#app_models_vendor__credit_eval_delegate_email').attr('required', true);
                    $('#delegate_credit_eval_btn').attr('disabled', false);
                    $('#app_models_vendor__credit_eval_delegate_email').parent().parent().addClass('required');
                } else if(state === 'off') {
                    $('#app_models_vendor__credit_eval_delegate_email').attr('disabled', true);
                    $('#app_models_vendor__credit_eval_delegate_email').attr('required', false);
                    $('#delegate_credit_eval_btn').attr('disabled', true);
                    $('#app_models_vendor__credit_eval_delegate_email').parent().parent().removeClass('required');
                }
            });
        }

        if ((delegated !== "" && delegated !== undefined && delegated !== null) && delegation_completed != null) {
            $('#credit_eval_delegate').attr('disabled', true);
        }

        $(document).on('click', '#delegate_credit_eval_btn', function(e) {
            const email_validate = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            let email =
                $('#app_models_vendor__credit_eval_delegate_email').val() ||
                $('#app_models_vendor_CreditEval_CreditEval_credit_eval_delegate_email').val();

            if (email && email_validate.test(email)) {
                abcsetup.alerts.confirm('Delegate Credit Evaluation Form?', `Are you sure you want to delegate the credit evaluation form for this workflow task to: ${email}?`, function (resp) {
                    if (resp) {
                        abcsetup.blockUI(true);

                        axios.post('/api/new_vendor/delegate_credit_eval', {
                            'id': JSON.parse($('#WorkflowTask').val()).id,
                            'credit_eval_delegate': true,
                            'credit_eval_delegate_email': email,
                        })
                        .then(response => {
                            const data = response.data;

                            if (data && data.success) {
                                const message = data.message;

                                abcsetup.unblockUI();

                                abcsetup.alerts.show("Successfully Delegated Task.", `You have successfully delegated this task to: ${email}. They have been sent an email letting them know that they have to complete the credit evaluation form for you. You may continue to complete other additional form tabs for this workflow task as you please.`);

                                /* display a banner saying the form tab is delegated */
                                $('.credit_eval_delegate_banner').removeClass('d-none');
                                $('.credit_eval_delegate_banner').append(`<span>${message}</span>`);
                                $('#delegate_credit_eval_btn').addClass('d-none');
                                $('#revoke_delegate_credit_eval_btn').removeClass('d-none');

                                /* make all credit eval form fields disabled and not required. */
                                if (type === 'consumer') {
                                    $('#app_models_vendor__credit_eval_delegate_email').attr('disabled', true);
                                    $('input, textarea, select, checkbox').each(function() {
                                        $(this).prop('disabled', true).prop('required', false);
                                    });
                                } else {
                                    $('#wiz-CreditEval').find('input, textarea, select, checkbox').each(function() {
                                        $(this).prop('disabled', true).prop('required', false);
                                    });
                                }

                                $('#credit_eval_delegate').attr('disabled', true);
                                state_type = 'sync';
                            }
                        })
                        .catch(error => {
                            console.error(error);
                            abcsetup.unblockUI();
                            abcsetup.alerts.show("Something went wrong.", `We encountered an issue trying to delegate this task to: ${email}. Please reach out to support and try again later. We apologize for the inconvenience.`);
                        });
                    }
                });
            } else {
                abcsetup.alerts.show("Invalid email entered.", "Please enter a valid email address.");
            }
        });

        $(document).on('click', '#revoke_delegate_credit_eval_btn', function(e) {
            let email = type === 'consumer'
                ? $('#app_models_vendor__credit_eval_delegate_email').val()
                : $('#app_models_vendor_CreditEval_CreditEval_credit_eval_delegate_email').val();

            abcsetup.alerts.confirm("Cancel Delegation Request", `Are you sure you want to cancel the credit evaluation form delegation request to ${email}? By canceling the request, you will be able to re-delegate the request to someone else or complete it yourself.`, function(resp) {
                if (resp) {
                    abcsetup.blockUI(true);

                    axios.post('/api/new_vendor/revoke_delegate_credit_eval', {
                        'id': JSON.parse($('#WorkflowTask').val()).id,
                    })
                    .then(response => {
                        const data = response.data;

                        if (data && data.success) {
                            const message = data.message;

                            abcsetup.unblockUI();

                            abcsetup.alerts.show("Successfully Revoked Delegation For Task.", message);

                            /* display a banner saying the form tab is delegated */
                            $('.credit_eval_delegate_banner').addClass('d-none');
                            $('.credit_eval_delegate_banner').empty();
                            $('#delegate_credit_eval_btn').removeClass('d-none');
                            $('#revoke_delegate_credit_eval_btn').addClass('d-none');

                            if (type === 'consumer') {
                                $(document).find('input, textarea, select, checkbox').each(function() {
                                    if ($(this).attr('id') != 'app_models_vendor__credit_eval_delegate_email') {
                                        $(this).removeAttr('readonly');
                                        $(this).removeAttr('disabled');
                                    }
                                });

                                $('#app_models_vendor__credit_eval_delegate_email').val(null);
                                $('#app_models_vendor__credit_eval_delegate_email').text(null);

                                if (state_type === 'sync') {
                                    //i give up
                                    $('#delegate_credit_eval_btn').attr('disabled', true);
                                    $('#credit_eval_delegate').prop('checked', false).prop('disabled', false).click().prop('checked', false);
                                } else {
                                    $('#credit_eval_delegate').prop('checked', false).prop('disabled', false)
                                }
                            } else {
                                $('#app_models_vendor_CreditEval_CreditEval_credit_eval_delegate_email').val(null);
                                $('#app_models_vendor_CreditEval_CreditEval_credit_eval_delegate_email').text(null);
                                $('#app_models_vendor_CreditEval_CreditEval_credit_eval_delegate_email').removeAttr('disabled');
                                $('#app_models_vendor_CreditEval_CreditEval_credit_eval_delegate_email').removeAttr('readonly');
                                $('#wiz-CreditEval').find('input, textarea, select, checkbox').each(function() {
                                    if ($(this).attr('id') != 'app_models_vendor_CreditEval_CreditEval_credit_eval_delegate_email') {
                                        $(this).removeAttr('readonly')
                                        $(this).removeAttr('disabled');
                                    }
                                });

                                $('#credit_eval_delegate').prop('checked', false).prop('disabled', false);
                                /* stupid ah hack but idk why it wont work otherwise */
                                $('#credit_eval_delegate').click();
                                setTimeout(() => {}, 100);
                                $('#credit_eval_delegate').click();
                            }
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        abcsetup.unblockUI();
                        abcsetup.alerts.show("Something went wrong.", error.data.message);
                    });
                }
            });
        });


        /* ABCS-3430 - hack to change icons if rejected */
        $(document).ready(function() {
            const workflowTask = JSON.parse($('#WorkflowTask').val());
            const userRole = abcsetup.userRole.class;

            if ((workflowTask.task === 'brx_other_supplier_forms' || workflowTask.task === 'grx_new_vendor_other_supplier_forms') && userRole === 'new_rx_vendor') {
                const rejectedTasks = $('#rejectedTasks').val();

                if (rejectedTasks) {
                    const tasks = JSON.parse(rejectedTasks);
                    const taskMap = {
                        'brx_atp_document_review': '#wiz-authorized_trading_partner',
                        'grx_new_vendor_atp_document': '#wiz-authorized_trading_partner',
                        'brx_credit_team_approval': '#wiz-CreditEval',
                        'grx_new_vendor_credit_team_approval': '#wiz-CreditEval',
                        'brx_insurance_docs_review': '#wiz-indemnification_insurance_contact',
                        'grx_new_vendor_insurance_docs_review': '#wiz-indemnification_insurance_contact'
                    };

                    Object.keys(tasks).forEach(task => {
                        const tabSelector = taskMap[tasks[task]];
                        if (tabSelector) {
                            const $tab = $(`a[href="${tabSelector}"]`).parent();
                            $tab.removeClass('complete').addClass('tab-error');
                            const $icon = $tab.find('i');
                            if ($icon.length) {
                                $icon.removeClass('fa-check ico-green').addClass('fa-times ico-red');
                            } else {
                                $(`a[href="${tabSelector}"]`).append('<i class="ico fa fa-times ico-red"></i>');
                            }
                        }
                    });
                }
            }
        });

        // Disable the effective date field for the authorized trading partner form
        if (this.workflow_task.task == 'brx_other_supplier_forms' || this.workflow_task.task == 'grx_new_vendor_other_supplier_forms' || this.workflow_task.task == 'consumer_other_supplier_forms') {
            $('#app_models_vendor_contact_authorized_trading_partner_authorized_trading_partner_effective_date').prop('readonly', true);
        }

        // Check how many alternate users are in the table and disable the approve all button if there are none
        $(document).ready(function() {
            if ($('#alternate_user_table tbody tr').length === 0 || $('#alternate_user_table tbody tr').find('input[type="radio"]:checked').length < $('#alternate_user_table tbody tr').length) {
                $('#approve-all-alternate-btn').prop('disabled', true);
            }
        
            $('input[type="radio"]').on('change', function() {
                const allRowsSelected = $('#alternate_user_table tbody tr').length === $('#alternate_user_table tbody tr').has('input[type="radio"]:checked').length;
                
                if (allRowsSelected) {
                    $('#approve-all-alternate-btn').prop('disabled', false);
                } else {
                    $('#approve-all-alternate-btn').prop('disabled', true);
                }
            });
        });

        /* ABCS-4894 */
         if (abcsetup.userRole.class == 'new_rx_vendor' && (this.workflow_task.task == 'brx_other_supplier_forms' || this.workflow_task.task == 'grx_new_vendor_other_supplier_forms')) {
            $(document).on('click', '.btn-validator', function(e) {
                let atpTabSelected = $('a[href="#wiz-authorized_trading_partner"]').parent().hasClass('current');
                let atLeastOneChecked = false;

                if (atpTabSelected) {
                    $('input[name="dscsa_statuses[]"]').each(function() {
                        if ($(this).is(':checked')) {
                            atLeastOneChecked = true;
                        }
                    });

                    if (!atLeastOneChecked) {
                        abcsetup.alerts.show('DSCSA Status Selection', 'Validation Error: Please select at least one DSCSA status to continue.');
                        $('.form_validate_feedback_dialog').hide();
                    }
                }
            });

            // FIXME: This is conflicting with ABCS-4856 - it's probably how we're submitting the form - commenting out for now
            // $(document).on('click', 'button[name="form_action"][value="approve"]', function (e) {
            //     e.preventDefault();
            //     let atLeastOneChecked = false;

            //     $('input[name="dscsa_statuses[]"]').each(function() {
            //         if ($(this).is(':checked')) {
            //             atLeastOneChecked = true;
            //         }
            //     });

            //     if (!atLeastOneChecked) {
            //         abcsetup.alerts.show('DSCSA Status Selection', 'Please select at least one DSCSA status on the Authorized Trading Partner tab to continue.');
            //         $('.form_validate_feedback_dialog').hide();
            //     } else {
            //         $(this).closest('form').submit();
            //     }
            // });
        }

        /* ABCS-4008 */
        if (this.workflow_task.task == 'consumer_other_supplier_forms' && abcsetup.userRole.class == 'new_consumer_vendor') {
            $(document).ready(function () {
                let isInitialLoad = true;

                let coi_tab = $('#wiz-indemnification_insurance_contact');
                coi_tab.find('div.toggle').each(function () {
                    $(this).closest('div.toggle').trigger('click');
                    $(this).closest('.toggle-row').hide();
                });

            
                handleLicenseTabVisibility(
                    $('#app_models_vendor_CoverSheet_CoverSheet_consumer_medical_devices').val(),
                    isInitialLoad
                );
            
                isInitialLoad = false;
            
                $(document).on('change', '#app_models_vendor_CoverSheet_CoverSheet_consumer_medical_devices', function (e) {
                    handleLicenseTabVisibility($(this).val(), isInitialLoad);
                });
            });
            
            function handleLicenseTabVisibility(val, isInitialLoad) {
                const stateLicenseTabs = ['#wiz-alabama_license', '#wiz-oregon_license', '#wiz-mississippi_license'];
            
                if (val == 1) {
                    stateLicenseTabs.forEach(function (stateLicenseTab) {
                        let tab = $(stateLicenseTab);
            
                        tab.find('div.toggle').each(function () {
                            if (!isInitialLoad) {
                                $(this).closest('div.toggle').trigger('click');
                            }
                            $(this).closest('.toggle-row').hide();
                        });
            
                        $('a[href="' + stateLicenseTab + '"]').closest('li').removeClass('d-none').attr('style', 'display: block;');
            
                        tab.find('input, select, textarea').not('[type="checkbox"]').each(function () {
                            $(this).attr('required', true);
                        });
                    });
                } else {
                    stateLicenseTabs.forEach(function (stateLicenseTab) {
                        let tab = $(stateLicenseTab);
            
                        tab.find('div.toggle').each(function () {
                            if (!isInitialLoad) {
                                $(this).closest('div.toggle').trigger('click');
                            }
                        });
            
                        $('a[href="' + stateLicenseTab + '"]').closest('li').hide();
                        tab.find('input, select, textarea').each(function () {
                            $(this).removeAttr('required');
                        });
                    });
                }
            }
        }
        
        if (this.workflow_task.task == 'consumer_new_vendor_gsmd_approve') {
            $(document).ready(function() {
                if ($('#app_models_vendor_CoverSheet_CoverSheet_consumer_medical_devices').val() == 1) {
                    $('a[href="#wiz-alabama_license"]').closest('li').show();
                    $('a[href="#wiz-mississippi_license"]').closest('li').show();
                    $('a[href="#wiz-oregon_license"]').closest('li').show();
                } else {
                    $('a[href="#wiz-alabama_license"]').closest('li').hide();
                    $('a[href="#wiz-mississippi_license"]').closest('li').hide();
                    $('a[href="#wiz-oregon_license"]').closest('li').hide();
                }
            });
        }

        // Fact Sheet/W9 Banking Field validation
        const bankingInputs = $(
            '#app_models_vendor_W9_W9_company_letter, #app_models_vendor_W9_W9_bank_statement, #app_models_vendor_W9_W9_bank_letter'
        );

        $('#app_models_vendor_W9_W9_company_letter').closest('.form-group').before('<div class="px-3"><hr/><p><b>Note: </b>Only 2 of the 3 documents below are required.</p></div>');
        
        bankingInputs.on('change', function() {
            abcsetup.new_vendor.workflow._checkBankingInputs(bankingInputs);
        });

        abcsetup.new_vendor.workflow._checkBankingInputs(bankingInputs);

        // Consumer Fact Sheet/W9 labeler codes
        if (this.workflow_task.task == 'consumer_supplier_forms' && abcsetup.userRole.class == 'new_consumer_vendor') {
            $('.LabelerCodes_number').removeAttr('required');
            $('#labeler_codes_wrapper').hide();

            $('#app_models_vendor_supplier_contact_supplier_contact_provide_upc_ndc').on('change', function() {
                if ($(this).val() == '1') {
                    $('#labeler_codes_wrapper').show();
                    $('.LabelerCodes_number').attr('required', true);
                } else {
                    $('#labeler_codes_wrapper').hide();
                    $('.LabelerCodes_number').removeAttr('required');

                    abcsetup.alerts.show('Warning:', 'You must select EA or CASE VC when submitting items through the portal.');
                }
            });
        }

    },
    
    /**
     * Apply any custom styles
     */
    _applyStyles: function() {
        // Dont apply to the new vendors
        if (abcsetup.userRole.class == 'new_rx_vendor' || abcsetup.userRole.class == 'new_consumer_vendor') {
            return false;
        }

        // Apply styles based on the expiration date value - expiration dates that are 60 days or less in the future as yellow
        function applyExpirationDateStyles($input) {
            if ($input.val()) {
                const given = moment($input.val(), "YYYY-MM-DD").startOf('day');
                const today = moment().startOf('day');
                const days = moment.duration(given.diff(today)).asDays();

                if (days <= 60 && days > 0) {
                    $input.closest('.form-group').addClass('alert alert-warning pl-0');
                    $input.closest('.form-group').append('<small class="pl-3 col-12"><b>WARNING: Expiration date is less than 60 days away</b></small>');
                } else if (days == 0) {
                    $input.closest('.form-group').addClass('alert alert-warning pl-0');
                    $input.closest('.form-group').append('<small class="pl-3 col-12"><b>WARNING: The Expiration date has passed. Please update it.</b></small>');
                } else {
                    $input.closest('.form-group').removeClass('alert alert-warning pl-0');
                    $input.closest('.form-group').find('small').remove();
                }
            }
        }

        // Initial application of styles
        $('input.expiration_date').each(function() {
            applyExpirationDateStyles($(this));
        });

        // Event listener for changes in the expiration date field
        $('input.expiration_date').on('change', function() {
            const $input = $(this);

            $input.closest('.form-group').removeClass('alert alert-warning pl-0');
            $input.closest('.form-group').find('small').remove();

            applyExpirationDateStyles($input);
            abcsetup.new_vendor.workflow._toggleApproveButtonState();
        });
    },

    /**
     * Check and toggle the approve button state based on expiration dates and pending license status
     */
    _toggleApproveButtonState: function() {
        if (abcsetup.userRole.class == 'csra_team' || abcsetup.userRole.class == 'gsmd_team') {

            let allLicensesValid = true;
            const licenseCheckboxes = $('.is-pending');

            // Iterate through each pending license checkbox and check if the associated license is expired
            licenseCheckboxes.each(function() {
                const stateLicense = $(this).attr('name').replace('_is_pending', '');
                const isPendingChecked = $(this).is(':checked');
                let isExpired = false;

                $(`input[name="${stateLicense}_expiration_date"]`).each(function() {
                    const $input = $(this);
                    const value = $input.val();

                    if (value) {
                        const given = moment(value, "YYYY-MM-DD");
                        if (moment().isSameOrAfter(given, 'day')) {
                            isExpired = true;
                        }
                    }
                });

                if (isExpired && !isPendingChecked) {
                    allLicensesValid = false;
                    return false; // Exit loop early if any license is invalid
                }
            });

            const approveButton = $('.btn-success[value="approve"]');

            // Enable or disable the approve button based on the allLicensesValid flag
            if (allLicensesValid) {
                approveButton.prop('disabled', false).removeClass('manual-disabled');
            } else {
                approveButton.prop('disabled', true).addClass('manual-disabled');
            }
        }
    },

    /**
     * Auto check and disabled the license checkboxes when divisions change
     */
    _applyLicenses: function(triggerControlledSubstances = true) {
        $(':checkbox[name^="licenses"]').attr('readonly', false);

        const selectedDivisions = $('#app_models_vendor_CoverSheet_divisions').val();

        // Division 10 is checked
        if (selectedDivisions.includes('10')) {
            $(':checkbox[name^="licenses"]').not('[value="secondary_dea"]').each(function() {
                $(this).prop('checked', true).attr('readonly', true);
            })
        }

        const nationalDC = $('#app_models_vendor_CoverSheet_CoverSheet_ship_through_national_dc').val();

        if (nationalDC == 1) {
            // Check off required state licenses
            $(':input[name^="licenses"][value="home_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="home_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="alabama_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="alabama_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="ohio_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="ohio_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="oregon_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="oregon_license"]').attr('readonly', true);

            // Un-check licenses not required when "Supplier will Ship through the National Distribution Center" question is "Yes"
            $(':input[name^="licenses"][value="colorado_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="colorado_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="florida_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="florida_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="mississippi_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="mississippi_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="texas_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="texas_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="missouri_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="missouri_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="north_carolina_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="north_carolina_license"]').attr('readonly', false);
        }

        // Division 20, 30, or 40 is checked AND national DC question is Yes
        if ((selectedDivisions.includes('20')) || (selectedDivisions.includes('30')) || (selectedDivisions.includes('40')) && nationalDC == 1) {
            // Check off required state licenses
            $(':input[name^="licenses"][value="home_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="home_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="alabama_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="alabama_license"]').attr('readonly', true);

            /* ABCS-4076 swapping these to not required or checked */
            $(':input[name^="licenses"][value="ohio_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="ohio_license"]').attr('readonly', false);


            $(':input[name^="licenses"][value="oregon_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="oregon_license"]').attr('readonly', true);

            // Un-check licenses not required when "Supplier will Ship through the National Distribution Center" question is "Yes"
            $(':input[name^="licenses"][value="colorado_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="colorado_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="florida_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="florida_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="mississippi_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="mississippi_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="texas_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="texas_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="missouri_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="missouri_license"]').attr('readonly', false);
            $(':input[name^="licenses"][value="north_carolina_license"]').prop('checked', false);
            $(':input[name^="licenses"][value="north_carolina_license"]').attr('readonly', false);
        }

        if ((selectedDivisions.includes('10')) && nationalDC == 0) {
            // Check off required state licenses
            $(':input[name^="licenses"][value="alabama_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="alabama_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="home_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="home_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="ohio_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="ohio_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="oregon_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="oregon_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="colorado_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="colorado_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="florida_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="florida_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="mississippi_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="mississippi_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="missouri_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="missouri_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="north_carolina_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="north_carolina_license"]').attr('readonly', true);
            $(':input[name^="licenses"][value="texas_license"]').prop('checked', true);
            $(':input[name^="licenses"][value="texas_license"]').attr('readonly', true);
        }

        // Licenses that are always required
        $(':input[name^="licenses"][value="alabama_license"]').prop('checked', true);
        $(':input[name^="licenses"][value="alabama_license"]').attr('readonly', true);
        $(':input[name^="licenses"][value="home_license"]').prop('checked', true);
        $(':input[name^="licenses"][value="home_license"]').attr('readonly', true);
        $(':input[name^="licenses"][value="oregon_license"]').prop('checked', true);
        $(':input[name^="licenses"][value="oregon_license"]').attr('readonly', true);

        //re check licenses that were previously saved
        if (this.workflow_task.task == 'brx_other_supplier_forms' || this.workflow_task.task == 'grx_new_vendor_other_supplier_forms' && triggerControlledSubstances) {
            let license_types = JSON.parse($('#WorkflowTask').val()).for_entity.licenses;

            for (let license in license_types) {
                $(':input[name^="licenses"][value="' + license_types[license] + '"]').prop('checked', true);
            }
        }

        // Trigger the license checkbox change
        $(':checkbox[name^="licenses"]:first').trigger('change');

        if (triggerControlledSubstances) {
            $('#app_models_vendor_CoverSheet_CoverSheet_controlled_substances').trigger('change');
        }
    },

    /**
     * Toggle the licenses tabs
     */
    _toggleLicenses: function() {
        $(':checkbox[name^="licenses"]').each(function() {
            var stateLicense = $(this).val();
            // The license is checked off
            if ($(this).prop('checked')) {
                $('a[href="#wiz-' + $(this).val() + '"]').closest('li').show();
            } else {
                $('a[href="#wiz-' + $(this).val() + '"]').closest('li').hide();

                // Turn off state license slider when license checkbox is unchecked
                if ($(':input[name^="disabled_tabs"][value="' + stateLicense + '"]').closest('div.toggle').hasClass('off')) {
                    $(':input[name^="disabled_tabs"][value="' + stateLicense + '"]').closest('div.toggle').trigger('click');
                }
            }
        });

        let state = $('#app_models_vendor_license_home_license_home_license_state').find(":selected").text()

        if (state) {
            $(".bs-vertical-wizard").find(`a:contains(${state})`).closest('li').hide();

            let titleModelStates = ['Colorado', 'Florida', 'Mississippi', 'Missouri', 'North Carolina', 'Ohio', 'Texas'];

            if (titleModelStates.includes(state)) {
                $('#app_models_vendor_license_home_license_home_license_title_model').attr('required', true);
                $('#app_models_vendor_license_home_license_home_license_title_model').parent().parent().addClass('required', true);
                $('#app_models_vendor_license_home_license_home_license_title_model').parent().parent().removeClass('d-none');
            } else {
                $('#app_models_vendor_license_home_license_home_license_title_model').val("0"); //set to "false" (0) for the Home State if not a title model state. ABCS-4331
                $('#app_models_vendor_license_home_license_home_license_title_model').attr('required', false);
                $('#app_models_vendor_license_home_license_home_license_title_model').parent().parent().addClass('required', false);
                $('#app_models_vendor_license_home_license_home_license_title_model').parent().parent().addClass('d-none');
            }
        }
    },

    _syncDuplicatedInputValues: function(value, inputGroup) {
        if (!((inputGroup === 'taxIDNumber' || inputGroup === 'duns') && ($('#app_models_vendor_contact_third_party_contact_third_party_contact_third_party_relationship').val() === '3PL') || ($('#app_models_vendor_contact_return_contact_return_contact_return_type').val() === '3pl'))) {
            abcsetup.new_vendor.workflow._duplicatedInputGroups()[inputGroup]
                .forEach(input => input.val(value));
        }
    },

    _duplicatedInputGroups: function() {
        return {
            taxIDNumber: [
                $('#app_models_vendor_contact_supplier_contact_supplier_contact_tin'),
                $('#app_models_vendor_contact_ship_from_contact_ship_from_contact_tin'),
                $('#app_models_vendor_contact_remit_to_contact_remit_to_contact_tin'),
                $('#app_models_vendor_contact_return_contact_return_contact_tin'),
            ],
            DEANumber: [
                $('#app_models_vendor_FederalControlledSubstance_FederalControlledSubstance_federal_dea_number'),
                $('#app_models_vendor_DEA_DEA_dea_number'),
                $('#app_models_vendor_MedicalDevices_MedicalDevices_medical_dea_number'),
            ],
            DEAExpiration: [
                $('#app_models_vendor_FederalControlledSubstance_FederalControlledSubstance_federal_expiration_date'),
                $('#app_models_vendor_MedicalDevices_MedicalDevices_medical_expiration_date'),
                $('#app_models_vendor_DEA_DEA_dea_expiration_date'),
            ],
            threePLName: [
                $('#app_models_vendor_FederalControlledSubstance_FederalControlledSubstance_federal_3pl_name'),
                $('#app_models_vendor_DEA_DEA_dea_3pl_name'),
                $('#app_models_vendor_MedicalDevices_MedicalDevices_medical_3pl_name'),
                $('#app_models_vendor_contact_third_party_contact_third_party_contact_name')
            ],
            threePLDEANumber: [
                $('#app_models_vendor_FederalControlledSubstance_FederalControlledSubstance_federal_3pl_dea_number'),
                $('#app_models_vendor_DEA_DEA_dea_3pl_number'),
                $('#app_models_vendor_MedicalDevices_MedicalDevices_medical_3pl_dea_number'),
            ],
            threePLExpiration: [
                $('#app_models_vendor_FederalControlledSubstance_FederalControlledSubstance_federal_3pl_expiration_date'),
                $('#app_models_vendor_DEA_DEA_dea_3pl_expiration_date'),
                $('#app_models_vendor_MedicalDevices_MedicalDevices_medical_3pl_expiration_date'),
            ],
            duns: [
                $('#app_models_vendor_contact_supplier_contact_supplier_contact_duns'),
                $('#app_models_vendor_contact_ship_from_contact_ship_from_contact_duns'),
                $('#app_models_vendor_contact_return_contact_return_contact_duns'),
            ],
            labelerCode: [
                $('#app_models_vendor_FederalControlledSubstance_FederalControlledSubstance_federal_labeler_code'),
                $('#app_models_vendor_DEA_DEA_dea_labeler_code'),
                $('#app_models_vendor_MedicalDevices_MedicalDevices_medical_labeler_code'),
            ],
            GS1LocationNumber: [
                $('#app_models_vendor_contact_supplier_contact_supplier_contact_gs1'),
                $('#app_models_vendor_contact_ship_from_contact_ship_from_contact_gs1'),
                $('#app_models_vendor_contact_return_contact_return_contact_gs1')
            ],
            GS1CompanyPrefix: [
                $('#app_models_vendor_contact_supplier_contact_supplier_contact_gs1_prefix'),
                $('#app_models_vendor_contact_ship_from_contact_ship_from_contact_gs1_prefix'),
            ],
            HIN: [
                $('#app_models_vendor_contact_supplier_contact_supplier_contact_hin'),
                $('#app_models_vendor_contact_ship_from_contact_ship_from_contact_hin'),
            ],
        }
    },

    // Check FactSheet/W9 Banking Fields
    _checkBankingInputs: function(bankingInputs) {
        const uploadedInputs = bankingInputs.filter(function () {
            return $(this).get(0).files.length > 0;
        });
    
        const uploadedCount = uploadedInputs.length;
    
        bankingInputs.each(function () {
            const input = $(this).get(0);
            const isUploaded = input.files.length > 0;
    
            if (uploadedCount >= 2) {
                input.required = false;
                input.setCustomValidity('');
                $(this).parent().parent().removeClass('required');
            } else {
                if (!isUploaded) {
                    input.required = true;
                    $(this).parent().parent().addClass('required');
                } else {
                    input.required = false;
                    input.setCustomValidity('');
                    $(this).parent().parent().removeClass('required');
                }
            }
        });
    },
}